"use client";

import { Provider as ReduxProvider } from "react-redux";
import { APIClientProvider, ApiConfig } from "~/api-client";
import { CurrencyProvider } from "~/hooks/currency";
import { ThemeProvider } from "~/hooks/theme";
import { createStore } from "~/store";
import { Theme } from "~/theme";
import { StripeProvider } from "./StripeProvider";

export function SiteProvider(props: {
  apiConfig: ApiConfig;
  stripePublishableKey: string;
  children: React.ReactNode;
}) {
  const store = createStore(props.apiConfig);

  const theme = new Theme();

  return (
    <APIClientProvider apiConfig={props.apiConfig}>
      <StripeProvider stripePublishableKey={props.stripePublishableKey}>
        <CurrencyProvider currency="USD">
          <ThemeProvider theme={theme}>
            <ReduxProvider store={store}>{props.children}</ReduxProvider>
          </ThemeProvider>
        </CurrencyProvider>
      </StripeProvider>
    </APIClientProvider>
  );
}
